"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatMapFiltered = void 0;
const is_defined_1 = require("../is-defined/is-defined");
/**
 * @summary Flat maps an array using a callback function.
 *
 * Flat maps an array using a callback function. If the array is `null` or `undefined`, an empty array is returned.
 * Any array item that is `null` or `undefined` will be skipped.
 *
 * @param {Array} array
 * @param {Function} callbackFn
 * @returns {Array}
 *
 * @example
 * const cleanedArray = flatMapFiltered(maybeDirtyArray, item => mapFiltered(item.values, subItem => new MyObject(subItem)));
 */
function flatMapFiltered(array, callbackFn) {
    return array?.filter(is_defined_1.isDefined).flatMap((v, i, a) => callbackFn(v, i, a) ?? []) ?? [];
}
exports.flatMapFiltered = flatMapFiltered;
